import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {AfterViewInit, ChangeDetectionStrategy, Component, DestroyRef, Input, ViewChild} from "@angular/core";
import {MatSelect, MatSelectModule} from "@angular/material/select";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldControl} from "@angular/material/form-field";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {MatFormFieldControlProxy} from "web-ng2/delt/material/MatFormFieldControlProxy";
import {InkludertGenerertDokument, TemaModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {harSammeId} from "felles-ng2/modell/modellHjelpere";
import {Subject} from "rxjs";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {TranslateModule} from "@ngx-translate/core";
import {l} from "../../../../../types/typescriptdefinisjoner_lederplan";
import {EnumOversettelser} from "../../../../../felles-ng2/tjenester/i18n/EnumOversettelser";
import {MatSelectTipsKomponent} from "../../../../delt/komponenter/mat-select-tips/mat-select-tips";

const debug = initDebugger('VelgTemaKomponent');


/** Viser nedtrekksmeny med temaer.
 *
 * <pre>
 * Fungerer med Ng reactive form via ([(skjemakontroll)]="...").
 * Fungerer med <mat-form-field> fra Material.
 *
 * MERK at vi ikke implementerer ControlValueAccessor fra angular.forms, så komponenten vil ikke fungere med
 * [(ngModel)]="..." eller [formControl]="...".
 * </pre>
 */
@Component({
    selector: 'velg-generert-dokument',
    templateUrl: './velg-generert-dokument.html',
    styleUrls: ['./velg-generert-dokument.scss'],
    providers: [{
        provide: MatFormFieldControl,
        useFactory: (komponent: VelgGenerertDokumentKomponent) => new MatFormFieldControlProxy(() => komponent.nedtrekksmeny, komponent.stateChanges),
        deps: [VelgGenerertDokumentKomponent]
    }],
    imports: [
        MatSelectModule,
        ReactiveFormsModule,
        MatSelectTipsKomponent,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VelgGenerertDokumentKomponent implements AfterViewInit {

    @ViewChild('dokumentvelger') private nedtrekksmeny!: MatSelect;

    @Input({required: true}) skjemakontroll!: FormControl<InkludertGenerertDokument | null>;
    @Input() placeholder = '';

    tilgjengeligeDokumenter: TilgjengeligDokument[] = [InkludertGenerertDokument.agenda, InkludertGenerertDokument.protokoll, InkludertGenerertDokument.forfalteOppgaver, InkludertGenerertDokument.ingen]
      .map(type => ({type: type, navn: this.enumOversettelser.oversettInkludertGenerertDokument(type)}))

    private readonly stateChanges = new Subject<void>();

    constructor(private enumOversettelser: EnumOversettelser, private destroyRef: DestroyRef) {
    }

    erValgt(a: TilgjengeligDokument | null, b: TilgjengeligDokument | null):boolean{
        return a === b;
    }

    ngAfterViewInit(): void {
        this.nedtrekksmeny.stateChanges
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(() => this.stateChanges.next())
    }

    //hjelpemetoder

}

interface TilgjengeligDokument {
    type: InkludertGenerertDokument;
    navn: string;
}
